import { Anchor } from "@svea/design-system-components-react";
import { Heading, P, Stack, SvgIcon, Text, useText } from "@sveabank/cc-common";
import { Link } from "react-router";

const BeneficialOwnerMissing = () => {
	const [t, texts] = useText();
	return (
		<Stack gap={4}>
			<Stack gap={2} direction="row">
				<SvgIcon imageSrc="ALERT" className="text-foreground-alert" />
				<Heading.H4>{t(texts.kyc.beneficialOwnership.boMissingTitle)}</Heading.H4>
			</Stack>
			<Stack gap={0}>
				<P bold>{t(texts.kyc.beneficialOwnership.stepOneTitle)}</P>
				<P>{t(texts.kyc.beneficialOwnership.stepOneDescription)}</P>
			</Stack>
			<Stack gap={0}>
				<P bold>{t(texts.kyc.beneficialOwnership.stepTwoTitle)}</P>
				<P>{t(texts.kyc.beneficialOwnership.stepTwoDescription)}</P>
			</Stack>
			<P className="text-text-error">
				<Text bold>{t(texts.kyc.beneficialOwnership.warningTitle)}</Text>
				{t(texts.kyc.beneficialOwnership.warningDescription)}
			</P>
			<Anchor
				as={Link}
				to={t(texts.kyc.beneficialOwnership.button.linkUrl)}
				target="_blank"
				iconEnd="externalLink"
			>
				{t(texts.kyc.beneficialOwnership.button.link)}
			</Anchor>
		</Stack>
	);
};

export default BeneficialOwnerMissing;
